import { SidePanelPropertyDescriptor } from 'src/graphql/entities/side-panel-personalization';
import { CreatedRow } from './created-row';
import {
  AssigneeRow,
  RequesterRow,
  StatusRow,
  TypeRow,
  UrgencyRow,
} from './form-property-rows';
import { LabelsRow } from './labels-row';

export const CONVERSATION_BASE_PROPERTIES: SidePanelPropertyDescriptor[] = [
  {
    key: 'base:status',
    label: 'Status',
    defaultVisible: true,
    Row: StatusRow,
    icon: 'play_circle',
  },
  {
    key: 'base:assignee',
    label: 'Assignee',
    defaultVisible: true,
    Row: AssigneeRow,
    icon: 'group',
  },
  {
    key: 'base:requester',
    label: 'Requester',
    defaultVisible: true,
    Row: RequesterRow,
    icon: 'person',
  },
  {
    key: 'base:type',
    label: 'Type',
    defaultVisible: true,
    Row: TypeRow,
    icon: 'support_agent',
  },
  {
    key: 'base:urgency',
    label: 'Urgency',
    defaultVisible: true,
    Row: UrgencyRow,
    icon: 'signal_cellular_3_bar',
  },
  {
    key: 'base:created',
    label: 'Created',
    defaultVisible: true,
    Row: CreatedRow,
    icon: 'calendar_today',
  },
  { key: 'base:labels', label: 'Labels', defaultVisible: true, Row: LabelsRow, icon: 'sell' },
];
